import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { FeeTableType } from '../ricFormTypes';
import {
  getFinalizedFees,
  formatCurrency,
  getFeesTotal,
} from '../ricFormUtils';
import { SectionItem, SubsectionItem, FeeTable } from '../Components';

const SchemaFeeTable = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement,
}: {
  formElement: FeeTableType;
  isSubSectionElement: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, columns, feeType, displayTotalValue } = formElement;

  const fees = getFinalizedFees(responseData?.finalizedFeeList ?? [], feeType);

  const HeaderComponent = isSubSectionElement ? SubsectionItem : SectionItem;
  const value = displayTotalValue ? formatCurrency(getFeesTotal(fees)) : null;
  return (
    <>
      <HeaderComponent title={title} subtitle={subtitle} value={value} />
      <div className="form-subsection">
        <FeeTable
          columns={columns}
          responseData={responseData}
          fees={fees}
          onChange={fetchResponseWithUpdatedData}
        />
      </div>
    </>
  );
};

export default SchemaFeeTable;
